document.addEventListener("DOMContentLoaded", function() {
  const targets = document.querySelectorAll(".js-scroll-slide");

  const options = {
    root: null,
    rootMargin: "0px 0px -10% 0px",
    threshold: 0
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-active");
      } else {
        entry.target.classList.remove("is-active");
      }
    });
  }, options);

  targets.forEach(function(target) {
    observer.observe(target);
  });
});